// import { FormEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { FormHandles, SubmitHandler } from '@unform/core';
import { Form } from '@unform/web';
import { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Logo } from '../../assets';
import { Button, Input, Loading } from '../../components';
import getValidationErrors from '../../utils/getValidationErrors';
import schemaValidation from '../../validation/login';
import * as S from './styles';
import { useAuth } from '../../hooks/useAuth';

interface FormData {
  login: string;
  password: string;
}

const Login = () => {
  const history = useHistory();
  const formRef = useRef<FormHandles>(null);
  const { signIn } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin: SubmitHandler<FormData> = async data => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      formRef.current?.setErrors({});

      await schemaValidation.validate(data, {
        abortEarly: false,
      });

      await signIn({ login: data.login, password: data.password });

      history.push(`${process.env.PUBLIC_URL}/register-os`);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRef.current?.setErrors(errors);
        return;
      }

      if (error?.response?.status === 401) {
        toast.error('Usuário/Senha incorretos');
      } else {
        toast.error('Não foi possível processar a solicitação');
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  });

  return (
    <S.Container>
      <div className="circle-outside">
        <div className="circle-inside" />
      </div>
      <S.Card>
        <img src={Logo} alt="Logomarca com o nome do CleanLab" />

        <Form ref={formRef} onSubmit={handleLogin}>
          <Input
            type="text"
            name="login"
            label="Login"
            containerStyle={{ marginBottom: '0.8rem' }}
          />

          <Input type="password" name="password" label="Senha" />

          <Button
            type="submit"
            disabled={isLoading}
            text={isLoading ? <Loading /> : 'Entrar'}
            containerStyle={{ width: '100%', marginTop: '2.4rem' }}
          />
        </Form>
      </S.Card>
    </S.Container>
  );
};

export default Login;
